export default "__VITE_ASSET__hZ3z5ndu__"